import portaoImagem from '../assets/imagensCards/portoes.png';
import galpaoImagem from '../assets/imagensCards/galpao.png';
import escadaImagem from '../assets/imagensCards/escadas.png';
import moveisImagem from '../assets/imagensCards/movel_planejado.png';
import corrimaoImagem from '../assets/imagensCards/corrimao_personalizado.jpeg';
import telhadoImagem from '../assets/imagensCards/telhado.png';

export const services = [
  {
    id: 1,
    title: "Portões",
    slug: "portoes",
    image: portaoImagem,
    alt: "Portão metálico residencial e comercial",
    shortDescription: "Portões sob medida para residências, empresas e condomínios.",
    features: [
      "Modelos Basculantes, Pivotantes e Deslizantes",
      "Estruturas em Aço Galvanizado de Alta Resistência",
      "Preparação e Suporte para Motor Automático",
      "Projetos Personalizados Sob Medida"
    ],
    icon: "FaDoorOpen",
    textoWpp: "Olá! Gostaria de solicitar um orçamento para um portão sob medida. Gostaria de saber mais sobre os modelos disponíveis, valores e prazo de execução."
  },

  {
    id: 2,
    title: "Galpões Metálicos",
    slug: "galpoes",
    image: galpaoImagem,
    alt: "Estrutura metálica para galpão industrial",
    shortDescription: "Estruturas resistentes para galpões industriais e comerciais.",
    features: [
      "Projetos para Áreas Industriais e Comerciais",
      "Cálculo Estrutural com Foco em Segurança",
      "Montagem Rápida e Eficiente no Local",
      "Fechamentos Metálicos e Telhas Termoacústicas"
    ],
    icon: "FaWarehouse",
    textoWpp: "Olá! Tenho interesse em construir um galpão metálico e gostaria de solicitar um orçamento. Posso enviar as medidas e mais informações sobre o projeto."
  },

  {
    id: 3,
    title: "Telhados e Coberturas",
    slug: "telhados",
    image: telhadoImagem,
    alt: "Cobertura metálica para residência e garagem",
    shortDescription: "Coberturas metálicas com excelente acabamento e vedação.",
    features: [
      "Estruturas para Garagens, Varandas e Áreas de Lazer",
      "Proteção Contra Vazamentos e Intempéries",
      "Opções com Telhas Galvanizadas ou Policarbonato",
      "Pintura Protetora de Longa Durabilidade"
    ],
    icon: "FaHouse",
    textoWpp: "Olá! Gostaria de solicitar um orçamento para um telhado ou cobertura metálica. Posso enviar as medidas e algumas fotos do local para avaliação."
  },

  {
    id: 4,
    title: "Móveis Planejados em Metal",
    slug: "moveis-planejados",
    image: moveisImagem,
    alt: "Móveis em estilo industrial e metal",
    shortDescription: "Móveis estilo industrial que unem resistência e elegância.",
    features: [
      "Design Estilo Industrial e Moderno",
      "Integração do Metal com Madeira ou Vidro",
      "Móveis Sob Medida",
      "Acabamento Fino e Soldas Invisíveis/Polidas"
    ],
    icon: "FaCouch",
    textoWpp: "Olá! Tenho interesse em móveis planejados em metal e gostaria de solicitar um orçamento. Gostaria de saber mais sobre as opções de projetos e acabamentos."
  },

  {
    id: 5,
    title: "Escadas Metálicas",
    slug: "escadas",
    image: escadaImagem,
    alt: "Escada metálica personalizada para ambiente interno ou externo",
    shortDescription: "Escadas metálicas sob medida priorizando segurança e design.",
    features: [
      "Modelos Caracol, Reta, em L ou em U",
      "Degraus em Chapa Xadrez, Madeira ou Grade",
      "Projetos Residenciais, Comerciais e Industriais",
      "Estrutura Reforçada de Alta Capacidade de Carga"
    ],
    icon: "FaStairs",
    textoWpp: "Olá! Gostaria de solicitar um orçamento para uma escada metálica sob medida. Posso enviar as medidas, fotos do local e informações sobre o modelo que procuro."
  },

  {
    id: 6,
    title: "Guarda-Corpos e Corrimãos",
    slug: "guarda-corpos",
    image: corrimaoImagem,
    alt: "Guarda-corpo e corrimão metálico",
    shortDescription: "Proteção e sofisticação para escadas, sacadas e varandas.",
    features: [
      "Conformidade com Normas de Segurança (NBR)",
      "Ideais para Escadas, Sacadas e Mezaninos",
      "Opções com Fechamento em Vidro ou Tubos",
      "Design Moderno com Acabamento Resistente"
    ],
    icon: "FaShieldAlt",
    textoWpp: "Olá! Gostaria de solicitar um orçamento para guarda-corpo ou corrimão. Tenho interesse em conhecer as opções de modelos, materiais e acabamentos disponíveis."
  },
];
